import React from "react";
import PropTypes from "prop-types";
import ReactOnRails from "react-on-rails";
import axios from "axios";
import serialize from "form-serialize";
import capitalize from "capitalize";
import Alert from "@shared/v2/Alert";
import Button from "@shared/v2/Button";
import TextToggle from "@shared/v2/TextToggle";

const TOGGLE_OPTIONS = [
  { value: true, label: "Enabled" },
  { value: false, label: "Disabled" },
];

const FeatureRow = ({ feature, featureToggle }) => {
  const [enabled, setEnabled] = React.useState(featureToggle?.enabled);

  return (
    <tr style={{ cursor: "pointer" }}>
      <td>{featureToggle?.id || ""}</td>
      <td>
        {feature.name
          .split("_")
          .map((element) => capitalize(element))
          .join(" ")}
      </td>
      <td>{feature.desc}</td>
      <td>{feature.category}</td>
      <td>
        <TextToggle
          options={TOGGLE_OPTIONS}
          name={feature.id}
          value={enabled}
          onChange={() => setEnabled((t) => !t)}
        />
      </td>
    </tr>
  );
};

FeatureRow.propTypes = {
  feature: PropTypes.shape().isRequired,
  featureToggle: PropTypes.shape({
    id: PropTypes.number,
    enabled: PropTypes.bool,
  }),
};

FeatureRow.defaultProps = {
  featureToggle: null,
};

class SupportAccountFeatures extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      featureToggles: props.feature_toggles,
      features: props.features,
      accountError: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { account } = this.props;
    this.setState({ isSubmitting: true });
    const featureUpdatePath = `/support/accounts/${account.id}/update_account_features`;
    const formData = serialize(e.target, { hash: true });
    axios
      .post(
        featureUpdatePath,
        { features: formData, authenticity_token: ReactOnRails.authenticityToken() },
        { headers: { "Content-Type": "application/json" } },
      )
      .then((res) => this.featuresUpdateSuccess(res))
      .catch((error) => {
        this.handleError(error.response.data);
      });
  };

  featuresUpdateSuccess = (response) =>
    this.setState({
      isSubmitting: false,
      featureToggles: response.data.feature_toggles,
      features: response.data.features,
    });

  handleError = (error) => this.setState({ isSubmitting: false, accountError: error });

  accountErrors = () => {
    const { accountError } = this.state;
    return <Alert text={accountError.errors.map((error) => `${error} `)} />;
  };

  render() {
    const { accountError, features, featureToggles, isSubmitting } = this.state;
    let displayError;
    if (accountError) {
      displayError = this.accountErrors();
    }
    return (
      <>
        {displayError}
        <form onSubmit={this.handleSubmit}>
          <fieldset disabled={isSubmitting ? "disabled" : false}>
            {displayError}
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Feature Toggle ID</th>
                  <th>Feature</th>
                  <th>Description</th>
                  <th colSpan={3}>Category</th>
                </tr>
              </thead>
              <tbody>
                {features.map((feature) => (
                  <FeatureRow
                    key={feature.id}
                    feature={feature}
                    featureToggle={featureToggles.find((t) => t.feature_id === feature.id)}
                  />
                ))}
              </tbody>
            </table>
            <div className="form-group">
              <Button size="medium" type="submit" isLoading={isSubmitting}>
                Save
              </Button>
            </div>
          </fieldset>
        </form>
      </>
    );
  }
}

SupportAccountFeatures.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  feature_toggles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      enabled: PropTypes.bool,
      feature_id: PropTypes.number,
    }),
  ).isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      desc: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default SupportAccountFeatures;
